import tw from "twin.macro";

export const Container = tw.div`relative bg-gray-100`;
export const PaddedContainer = tw.div`flex flex-col relative bg-gray-100 lg:flex-row md:items-center p-10 mx-auto py-20 md:py-24`;
export const ContentWithPaddingXl= tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
export const ContentWithPaddingLg= tw.div`max-w-screen-lg mx-auto py-20 lg:py-24`;
export const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
export const Content2Xl= tw.div`max-w-screen-2xl mx-auto`;
